"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

exports.default = true;
//# sourceMappingURL=browser.js.map
